import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ApplicationService } from "@app/applications/application.service";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { OnDestroy } from "@angular/core";
import { Applicant } from "@app/applications/application-details/collateral/collateralDetails/collateral-details.model";
import { ValidationService } from "@app/applications/application-validators/validation.service";
import { ReferenceCodeService } from "@app/admin/reference-code/reference-code.service";
import { BureauRequestDto, BureauResponse } from "../xdata-response.model";
import { ConfirmationDialogService } from "@app/utils/confirmation-dialog/confirmation-dialog.service";
import { SecureStorageService } from "@ig-core/authentication/secureStorage.service";
import { ConsentResponseDto, SMSRequestDTO } from "@app/applications/applications.model";
import { ReferenceCode } from "@app/admin/reference-code/reference-code.model";
import { SOURCE_DIGITAL } from "@app/constants/data.constants";
import { XDataRequestDTO, XDataRequestGroup } from "../xdata-registry.model";
@Component({
  selector: "eng-bureau-cibil",
  templateUrl: "bureau-cibil.template.html",
  styleUrls: [
    "../../../application-details.styles.scss",
    "../xdata-service.style.scss",
  ],
})
export class BureauCibilComponent implements OnInit, OnDestroy {
  applicationUid: string;

  cibilDetailsForm: FormGroup;
  serviceProviderCode: string;
  applicants: Applicant[];
  selectedRequest: BureauResponse = {};
  alternateNumberOrOtp: string = '';
  otp: string = '';
  emailOtp: string = '';
  showValidateMobileNumber: boolean = false;
  mobileNumberValidated: boolean = false;
  smsRequest: SMSRequestDTO = {};
  mobileNumber: string;
  consentResponse: ConsentResponseDto;
  personUid: string;
  party: string;
  consentOtp: string = '';
  showConsentOtpSection: boolean = false;
  cibilConsentRefcode: ReferenceCode[];
  showConsentOnSettingsRefcode: boolean = false;
  bureauRequestDto: BureauRequestDto = {};
  hideNewRequestButton: boolean = false;
  xdataRequests: XDataRequestGroup[] = [];
  email: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private _snackbar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private secureStorageService: SecureStorageService,
    private referenceCodeService: ReferenceCodeService
  ) {
    this.cibilDetailsForm = this.formBuilder.group({
      borrower: ["", Validators.required],
      mobileNumber: ["", Validators.required],
      email: ["", Validators.required]
    });
    this.activatedRoute.queryParams
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.applicationUid = params.applicationUid;
        this.serviceProviderCode = params.xDataService;
      });
  }

  ngOnInit() {
    this.getRefCodes();
    this.getApplicants();
    this.getCibilRequests();
  }

  getRefCodes() {
    this.referenceCodeService.getRefCodesForClassifier('bureau_settings').subscribe((response: any) => {
      this.cibilConsentRefcode = response;
      this.cibilConsentRefcode.forEach(element => {
        if (element.code == "CIBIL-CONSENT") {
          if (element.field1 !== null && element.field1.trim().toLocaleLowerCase() === 'otp') {
            this.showConsentOnSettingsRefcode = true;
          }
        }
      })
    })
  }

  getApplicants() {
    this.applicationService.getApplicants(this.applicationUid).subscribe((response: any) => {
      if (response) {
        this.applicants = response;
      }
    });
  }

  getCibilRequests() {
    this.applicationService.fetchBureauCibilRequests(this.applicationUid).subscribe(response => {
      this.xdataRequests = response.body;
    })
  }

  onBorrowerChange(borrower) {
    // previous value will be stored in mobileNumber, hence we are reseting the value to empty
    this.cibilDetailsForm.controls.mobileNumber.patchValue("");
    this.cibilDetailsForm.controls.email.patchValue("");
    this.cibilDetailsForm.patchValue({
      mobileNumber: borrower.primaryPhone,
      email: borrower.email
    });
    this.getCibilStatus();
    this.cibilDetailsForm.controls.mobileNumber.disable();
    this.cibilDetailsForm.controls.email.disable();
  }

  getCibilStatus() {
    this.personUid = this.cibilDetailsForm.getRawValue().borrower.uid;
    this.party = this.cibilDetailsForm.getRawValue().borrower.play;
    this.mobileNumber = this.cibilDetailsForm.getRawValue().mobileNumber;
    this.email = this.cibilDetailsForm.getRawValue().email;
    this.selectedRequest = {};
    this.consentResponse = null;

    if (this.xdataRequests && this.xdataRequests.length == 0) {
      return;
    }

    let filteredRequests = this.xdataRequests[0].xdataRequestDTOs.filter(req => req.linkToUid === this.personUid);
    let sortedRequest = filteredRequests.sort((a, b) => b.id - a.id);

    if (sortedRequest && sortedRequest.length == 0) {
      return;
    }

    if (sortedRequest[0].internalStatus.toLocaleUpperCase() === 'INPROCESS') {
      this.applicationService.getAuthQuestion(this.applicationUid, this.party, this.personUid, sortedRequest[0].serviceProviderReferenceId).subscribe(response => {
        this.selectedRequest = response;
        return;
      })
    }
  }

  initiateNewRequest() {
    if (!this.validateMobileNumber(this.mobileNumber)) {
      return;
    }
    this.preValidateForInitiation();
  }

  preValidateForInitiation() {
    this.applicationService.preValidate(this.applicationUid, this.party, this.personUid)
      .subscribe((response: any) => {
        // if any of the validation is faild it will give 400 it will go to failure case, hence if there is resposne then we can proceed further
        if (response) {
          this.applicationService.getConsentStatus(this.applicationUid, this.personUid, this.mobileNumber)
            .subscribe((response) => {
              if (response.body) {
                this.consentResponse = response.body;
              } else {
                this.sendOtpToMobileNo();
              }
            })
        }
      })
  }

  sendOtpToMobileNo() {
    this.smsRequest.requestedBy = this.secureStorageService.secureSessionStorage.getItem("logInUserDetails").login;
    this.smsRequest.isOTP = true;
    this.smsRequest.requestApp = "webapp";
    this.smsRequest.requestLat = 0.00;
    this.smsRequest.requestLng = 0.00;
    this.smsRequest.mobileNumber = this.mobileNumber;

    this.applicationService.sendOtpToValidateMobileNo(this.applicationUid, this.personUid, this.mobileNumber, this.smsRequest).subscribe((response) => {
      this._snackbar.open(response.body.message, "close", {
        duration: 7000
      })
      if (response.body.status == "success") {
        this.selectedRequest = new BureauResponse();
        this.showValidateMobileNumber = true;
        this.mobileNumberValidated = false;
        this.hideNewRequestButton = true;
        this.cibilDetailsForm.controls.borrower.disable();
      }
    }, (failure) => {
      this._snackbar.open(failure, "close", {
        duration: 7000
      })
    });
  }

  submitOTP() {
    let trimmedOtp = this.otp.trim();
    if (!trimmedOtp) {
      this._snackbar.open("Please enter OTP", "Close", {
        duration: 6000,
      });
      return;
    }

    this.setSmsRequest(trimmedOtp);
    this.applicationService.confirmOtpSentToMobileNo(this.applicationUid, this.personUid, this.mobileNumber, this.smsRequest).subscribe((response) => {
      if (response.body.status == "success") {
        this.applicationService.sendConsentLink(this.applicationUid, this.personUid, this.mobileNumber).subscribe((response) => {
          this.consentResponse = response;
          this.mobileNumberValidated = true;
          this._snackbar.open(response.message, "close", {
            duration: 7000
          })
        })
      } else {
        this._snackbar.open(response.body.message, "Close", {
          duration: 7000
        });
      } (failure) => {
        this._snackbar.open(failure, "close", {
          duration: 8000
        })
      }
    });
  }

  resendConsentLink() {
    this.applicationService.reSendConsentLink(this.applicationUid, this.personUid, this.consentResponse.consentUid, this.mobileNumber).subscribe((response) => {
      this.consentResponse = response;
      this._snackbar.open(response.message, "Close", {
        duration: 8000,
      })
    })
  }

  checkConsentStatus() {
    this.applicationService.refreshConsentStatus(this.applicationUid, this.personUid, this.consentResponse.consentUid).subscribe((response) => {
      this.consentResponse = response;
      this._snackbar.open(response.message, "Close", {
        duration: 8000,
      })
    })
  }

  sendConsentOtp() {
    this.applicationService.sendConsentOtp(this.applicationUid, this.personUid, this.consentResponse.consentUid, this.mobileNumber).subscribe((response) => {
      this.consentResponse = response;
      if (response.status == 'success') {
        this.showConsentOtpSection = true;
      }
      this._snackbar.open(response.message, "Close", {
        duration: 8000,
      })
    })
  }

  reSendConsentOtp() {
    this.applicationService.reSendConsentOtp(this.applicationUid, this.personUid, this.consentResponse.consentUid, this.mobileNumber).subscribe((response) => {
      this.consentResponse = response;
      this._snackbar.open(response.message, "Close", {
        duration: 8000,
      })
    })
  }

  submitConsentOtp() {
    let trimmedConsentOtp = this.consentOtp.trim();
    if (!trimmedConsentOtp) {
      this._snackbar.open("Please enter OTP", "Close", {
        duration: 6000,
      });
      return;
    }

    this.setSmsRequest(trimmedConsentOtp);
    this.applicationService.confirmConsentOtp(this.applicationUid, this.personUid, this.consentResponse.consentUid, this.smsRequest).subscribe((response) => {
      this.consentResponse = response.body;
      this._snackbar.open(response.body.message, "close", {
        duration: 7000
      })
    }
    )
  }

  callFulfillOffer() {
    this.applicationService.initBureaurRequest(this.applicationUid, this.party, this.personUid).subscribe((response) => {
      this.selectedRequest = response
      this.cibilDetailsForm.disable();
    },(failure) => {
      this._snackbar.open(failure, "Close", {
        duration : 8000
      })
    })
  }

  viewReport() {
    this.applicationService.viewBureauReport(this.applicationUid, this.party, this.personUid, this.selectedRequest.requestReferenceId).subscribe((response) => {
      window.open(response.body, '_blank');
    })
  }

  // this is common method that will be called for skip, resendOtp, alternateMobileNumber, emailOTP, mobileNumberOtp
  submitMobileNumberOrOtp(skipOrResendOtp?: string, statusCode?: string) {
    // if it is in inprocess state and we continue further, then after completing initiate new request will be shown.
    // hence to hide it we are making "hideNewRequestButton" as true
    this.hideNewRequestButton = true;
    this.cibilDetailsForm.controls.borrower.disable();
    this.bureauRequestDto = new BureauRequestDto();
    let trimmedInput = this.alternateNumberOrOtp.trim();

    if (!skipOrResendOtp) {
      if (statusCode === 'ALT_MOB' && !this.validateMobileNumber(trimmedInput)) {
        return;
      }

      if (statusCode !== 'ALT_MOB' && !trimmedInput) {
        this._snackbar.open("OTP is required.", "Close", {
          duration: 5000
        });
        return;
      }
    }

    this.bureauRequestDto.challengeId = this.selectedRequest.challengeId;
    this.bureauRequestDto.answerId = this.selectedRequest.answerId;
    this.bureauRequestDto.questionId = this.selectedRequest.questionId;
    this.bureauRequestDto.requestReferenceId = this.selectedRequest.requestReferenceId;
    this.bureauRequestDto.currentStep = this.selectedRequest.statusCode;

    if (skipOrResendOtp === 'skip') {
      this.bureauRequestDto.skipQuestion = true;
      this.bureauRequestDto.answerText = null;
    } else if (skipOrResendOtp === 'resendOtp') {
      this.bureauRequestDto.resendOtp = true;
      this.bureauRequestDto.answerText = null;
    } else {
      this.bureauRequestDto.skipQuestion = false;
      this.bureauRequestDto.answerText = trimmedInput ? trimmedInput : null;
    }

    this.applicationService.verifyAuthAnswer(this.applicationUid, this.party, this.personUid, this.selectedRequest.requestReferenceId, this.bureauRequestDto).subscribe((response) => {
      this.selectedRequest = response.body;
      this._snackbar.open(this.selectedRequest.message, "Close", {
        duration: 8000
      })

      // after api call we need to clear input field value hence we are resetting this field 
      this.alternateNumberOrOtp = '';
    })
  }

  validateMobileNumber(mobileNumber) {
    if (!mobileNumber) {
      this._snackbar.open("Mobile number is required.", "Close", {
        duration: 5000
      })
      return false;
    }

    let trimmedMobileNumber = mobileNumber.trim();
    if (trimmedMobileNumber) {
      let regex = new RegExp(/^[6-9]\d{9}$/);
      if (!regex.test(trimmedMobileNumber)) {
        this._snackbar.open("Invalid mobile number. Must be 10 digits, starting with 6-9.", "Close", {
          duration: 7000
        });
        return false;
      }
    }
    return true;
  }

  setSmsRequest(otp) {
    this.smsRequest.otp = otp;
    this.smsRequest.usedBy = this.secureStorageService.secureSessionStorage.getItem("logInUserDetails").login;
    this.smsRequest.usedApp = "webapp";
    this.smsRequest.usedLat = 0.00;
    this.smsRequest.usedLng = 0.00;
    this.smsRequest.mobileNumber = this.mobileNumber;
  }

  ngOnDestroy(): void { }
}
